import React, { Component } from "react";


class Tip extends Component {


    render() {

        return (
            this.props.showOn ?
                <div id="tipBox" style={this.props.tipStyle ? this.props.tipStyle : {}}>
                    {this.props.msg}
                </div> : null
        );
    }
}

export default Tip;


// WEBPACK FOOTER //
// ./src/jsx/components/utility/tip.jsx